import type { Level } from "./types";

export const limenLevel: Level = {
  id: "limen",
  title: "Limen",
  word: "LIMEN",
  copy: {
    start: "Start",
    loseTitle: "The threshold held.",
    win: [
      "The gate is not a door. It is a facing.",
      "Deep sleep has another room. You found the hinge.",
      "Across the ring, the same hour waited.",
      "The parallel is not beside you. It is opposite.",
      "What you met was yourself, twelve hours later.",
      "The oval does not split the dream. It holds it.",
      "You did not wake. You crossed.",
      "The other side was already breathing with this one.",
      "A circle has no above. Only away and toward.",
      "The passage is the moment two edges remember they are one.",
      "Inside the ring the wind only knew how to turn.",
      "You entered by agreeing to be two places at once.",
    ],
    lose: [
      "The ring ate what did not face itself.",
      "Beside is not across. The seam knows the difference.",
      "Twelve hours. Only the opposite hour opens.",
      "What arrived together in the same place was only food.",
      "The vortex kept turning. You never met the other side.",
      "One point on the ring is a hunger. Two, a door.",
      "Too close on the clock. Too far from the antipode.",
      "The passage needs a diameter, not a cluster.",
      "Inside is allowed. The rim is not a wall to feed.",
      "You filled the oval and never looked across it.",
      "The other side was waiting at six, and you stayed at twelve.",
      "A meeting that is not opposite is only more sleep.",
      "The ring closed. The inside became a rumour.",
    ],
  },
  rules: {
    score: { type: "meet-opposite", maxErrorDeg: 30 },
    win: { type: "score" },
    lose: { type: "divider-or-region", fraction: 0.7 },
    extras: [],
  },
  objects: [{ kind: "oval-seam", id: "ring" }],
  audio: {
    bed: "synth-pass",
    sources: [],
  },
  world: {
    divider: {
      shape: "oval",
      ovalInsetX: 0.07,
      ovalInsetY: 0.1,
      /** Grossura da costura a que se perde. Independente do Onirya. */
      thicknessMax: 280,
      spaceLoseAt: 0.7,
    },
    score: {
      meetMode: "opposite",
      oppositeErrorDeg: 30,
    },
    visual: {
      swapEnvironments: true,
    },
    audio: {
      bedId: "synth-pass",
    },
    wind: {
      strength: 0.00022,
      turbulence: 1.35,
      lateralBias: 1.5,
      verticalBias: 0.18,
    },
  },
};
